import { createContext, useCallback, useState } from 'react';
import { INotification } from '../models/INotification';
import { NotificationType } from '../models/NotificationType';
import { NotificationContainer } from '../components/NotificationContainer';

interface INotificationContext {
  addNotification: (message: string, type: NotificationType, time?: number) => void;
  notifications: INotification[];
}

export const NotificationContext = createContext<INotificationContext>({
  addNotification: null,
  notifications: [],
});

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const addNotification = useCallback(
    (message: string, type: NotificationType, time?: number) => {
      setNotifications((notifications) => [
        ...notifications,
        { message, type, time: time || 5000 },
      ]);
    },
    [],
  );
  return (
    <NotificationContext.Provider
      value={{
        addNotification,
        notifications,
      }}
    >
      <NotificationContainer notifications={notifications} />
      {children}
    </NotificationContext.Provider>
  );
};
